import { render, staticRenderFns } from "./AllFeedbacks.vue?vue&type=template&id=90e95368&"
import script from "./AllFeedbacks.vue?vue&type=script&lang=ts&"
export * from "./AllFeedbacks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports